module.exports = "<div class=ready-wrapper><div class=ready-container><div class=ready-label-container><p class=ready-label translate>PUBLIC.THANK_YOU</p></div><div class=ready-content-container><p class=ready-content-text translate>PUBLIC.SUCCESS_MESSAGE</p><p class=ready-content-text translate>PUBLIC.BON_VOAYAGE</p><div class=ready-content-image-container><img class=ready-content-image src=/assets/images/Bus-icon.png alt=\"\"></div></div></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/public/main/payment-ready/payment-ready.html
 ** module id = 210
 ** module chunks = 0
 **/